export const BASE_PATH = process.env.REACT_APP_BASE_PATH
export const BASE_PATH_EXTENSION = process.env.REACT_APP_BASE_PATH_EXTENSION
export const BASE_PATH_EXTENSION_ADMIN = process.env.REACT_APP_BASE_PATH_EXTENSION_ADMIN
export const TOKEN = process.env.REACT_APP_TOKEN
export const DASH_MAX_ROW = 50
